import ReactDOM from 'react-dom';
import { routing } from './AppRouting';

import './assets/styles/sass/index.scss';

ReactDOM.render(routing, document.getElementById('root'));
